import { FC } from 'react';
import { AdminCardFees } from 'containers/admin';
import { AdminCardLayout } from 'pages/atoms';

const AdminCardFeesPage: FC = () => {
  return (
    <AdminCardLayout>
      <AdminCardFees />
    </AdminCardLayout>
  );
};

export default AdminCardFeesPage;
